/**
 * Manages the download links for downloadable items (resource items etc) that can be in multiple languages.
 */

(function($) {
  //console.log(" In jquery.downloadable.js");


  $( document ).on( 'ready facetwp-loaded', function () {

	$(".downloadable--wrap").each( function( index ) {
		initial_load( $( this ).data( 'post-payload' ), index );
	});
		/*
		payload is a JSON-encoded array of items stored in a data attribute that define the select box relationships. It
		is embedded by the DownloadableItem class. See DownloadableItem for how this is
			<post_id> (array):
				by_dim (array):
					<size taxonomy slug 1> (array):
						<language code 1>: <button ID for this size and language combination (string)
						<language code 2>: <button ID for this size and language combination (string)
					<size taxonomy slug 2> (array):
						<language code 1>: <button ID for this size and language combination (string)
						<language code 2>: <button ID for this size and language combination (string)
				by_lang (array):
					<language code 1> (array):
						<size taxonomy slug 1>: <button ID for this size and language combination (string)
						<size taxonomy slug 2>: <button ID for this size and language combination (string)
					<language code 2> (array):
						<size taxonomy slug 1>: <button ID for this size and language combination (string)
						<size taxonomy slug 2>: <button ID for this size and language combination (string)
				labels (array):
					<size taxonomy slug 1>: <size taxonomy label 1> (string)
					<size taxonomy slug 2>: <size taxonomy label 1> (string)
					<language code 1>: <language code 1> (string)
					<language code 2>: <language code 1> (string)
				switches (array):
					doing_dimensions: BOOL (bool)
					post_id: <post ID> (string)

		Notes:
		1. There can be any number of lang and dim entries, and they may not be of equal size.
		2. The labels are already localized
		 */
	});
})(jQuery);



/**
 * Does the initial setup for each downloadable item.
 *
 * @param item_as_sent   array  The array of properties for this DI.
 * @param index          int    The current index in the forEach loop
 */
function initial_load( item_as_sent, index ) {
	$ = jQuery;
	//console.log( index );

	// Get the array key, given we know there is only one at this point.
	var item          = item_as_sent[0];
	var post_id       = Object.keys( item );
	var post_id_class = '.id_' + post_id;
	var doing_dim     = item[ post_id ][ 'switches' ][ 'doing_dimensions' ];

	//Start by hiding all the download links
	$( post_id_class + ' .downloadable-item' ).hide();

	if ( doing_dim ) {
		console.log( "Doing Dimensions; initial load" );
		// Language is set as selected so use that as the way to set the default size
		enable_correct_button( $, item, post_id_class, true );
	} else {
		console.log( "Not Doing Dimensions" );
		//Show the site language's download link
		$( ":selected" ).each( function () {
			console.log( $( this ).val() );
			$( '.id_' + $( this ).val() ).closest( 'div' ).show();
		} );
	}

	check_for_single_options( $, post_id_class + ' .id_language_picker' );
	check_for_single_options( $, post_id_class + ' .id_dimensions_picker' );

	//When a user selects a different language from the dropdown, show that language's download link
	$( post_id_class + ' .id_language_picker' ).change( function () {
		console.log( post_id + " Changed" );
		// Reset any of the other container divs that were previously marked 'active'
		$( 'div.resource_item' ).removeClass( "active" );
		// For the dropdown that just changed, mark the containing div as 'active'
		$( this ).closest( 'div.resource_item' ).addClass( "active" );
		if ( doing_dim ) {
			// Hide all buttons
			$( '.active .downloadable-item' ).hide();

			// Fix the dropdown for the dimension picker, which will now need to be updated based on the language selected
			fix_dropdown( $, item, post_id, post_id_class, '.id_dimensions_picker', '.id_language_picker' );
			// Enable the correct button for the lang + dim combination
			enable_correct_button( $, item, post_id_class );
		} else {
			console.log( "Not Doing Dimensions" );
			// Hide all the buttons
			$( '.active .buttons' ).find( "a" ).closest( 'div' ).hide();
			// Reveal only the button that matches the selection
			$( '.active .buttons' ).find( '.id_' + $( this ).val() ).closest( 'div' ).show();
		}
	} );

	// When a user selects a different language from the dropdown, show that language's download link
	$( post_id_class + ' .id_dimensions_picker' ).change( function () {
		console.log( post_id + " Changed" );
		// Reset any of the other container divs that were previously marked 'active'
		$( 'div.resource_item' ).removeClass( "active" );
		// For the dropdown that just changed, mark the containing div as 'active'
		$( this ).closest( 'div.resource_item' ).addClass( "active" );

		// Always doing dim if here, so hide all the buttons
		$( '.active .downloadable-item' ).hide();
		// Fix the dropdown for the language picker, which will now need to be updated based on the dimension selected
		fix_dropdown( $, item, post_id, post_id_class, '.id_language_picker', '.id_dimensions_picker' );
		// Enable the correct button for the lang + dim combination
		enable_correct_button( $, item, post_id_class );
	} );
}


/**
 * Disables a select box if there is only one option.
 *
 * @param $                      object   jQuery object
 * @param select_box
 */
function check_for_single_options( $, select_box ) {
	if ( 1 === $( select_box ).children('option').length ) {
		$( select_box ).prop('disabled', 'disabled');
	}
}


/**
 * General function to adjust the dropdown
 * @param $                      object   jQuery object
 * @param item                   array    The array of properties for this DI.
 * @param post_id                string   Post ID
 * @param post_id_class          string   Post ID formatted as the class selecter
 * @param dropdown_to_fix        string   The class selector for the dropdown the reset and reload
 * @param dropdown_that_changed  string   The class selector for the dropdown that was changed
 */
function fix_dropdown( $, item, post_id,  post_id_class, dropdown_to_fix, dropdown_that_changed ) {
	// If we are here, then the language dropdown was just changed.
	// Rebuild the dimension options to valid ones. What are the valid ones? that is found in payload.
	var selected = $( post_id_class + '.active ' + dropdown_that_changed ).find( ":selected" ).val();
	console.log( "Rebuilding " + selected );
	console.log( post_id_class + '.active ' + dropdown_that_changed );

	var type = 'by_lang';
	if ( '.id_language_picker' === dropdown_to_fix ) {
		type = 'by_dim';
	}

	// clear all options from dimension select
	$( post_id_class + '.active ' + dropdown_to_fix )
	.find( 'option' )
	.remove()
	.end();

	// Re-create them
	// @src https://stackoverflow.com/questions/740195/adding-options-to-a-select-using-jquery
	Object.keys( item[ post_id ][ type ][ selected ] ).forEach( function ( selected, index ) {
		console.log( "  Adding " + item[ post_id ][ 'labels' ][ selected ] + "(" + selected + ")" );
		var o = new Option( item[ post_id ][ 'labels' ][ selected ], selected );
		// jquerify the DOM object 'o' so we can use the html method
		jQuery( o ).html();
		jQuery( '.active ' + dropdown_to_fix ).append( o );
	} );

	// Set the first item as selected
	jQuery( '.active ' + dropdown_to_fix ).val( jQuery( ".active " + dropdown_to_fix + " option:first" ).val() );
}



/**
 * Find the correct button based on selections made in the UI
 *
 * @param $                      object   jQuery object
 * @param item                   array    The array of properties for this DI.
 * @param post_id_class          string   Post ID formatted as the class selecter
 * @param is_initial_load        bool     true if it's the page load case; false otherwise. Default false
 */
function enable_correct_button( $, item, post_id_class, is_initial_load = false ) {
	console.log( "Finding Button" );
	var class_id = post_id_class;
	if ( !is_initial_load ) {
		class_id += '.active';
	}

	// Get selected lang
	var selected_lang = $( class_id + ' .id_language_picker' ).find( ":selected" ).val();
	console.log( "  Lang: " + selected_lang );
	console.log( class_id + ' .id_language_picker' );

	var selected_dim = $( class_id + ' .id_dimensions_picker' ).find( ":selected" ).val();
	console.log( "  Dim: " + selected_dim );

	// Now activate the correct button
	$( class_id + ' .id_' + selected_lang + '__' + selected_dim ).closest( 'div' ).show();
}
